module.exports = __webpack_public_path__ + "img/newsIndImg4.a53f273b.png";